export const getInitials = (name:string) => {
    if (!name) {
        return 'HM';
    }
    const newName = name.split(' ');
    if (newName.length === 1) {
        return newName[0].charAt(0);
    }
    if (newName.length === 2) {
        return newName[0].charAt(0) + newName[1].charAt(0);
    }
    return newName[0].charAt(0) + newName[2].charAt(0);
};


// WEBPACK FOOTER //
// ./node_modules/strip-loader/lib?strip[]=console.log,strip[]=console.error!./node_modules/tslint-loader??ref--4!./src/js/utils/StringUtils.tsx